import React from 'react';
import styled from 'styled-components';
import {backgroundColor2, fontSize2} from '../Shared/Styles';
import {AppContext} from '../App/AppProvider';
import _ from 'lodash';
import fuzzy from 'fuzzy';

const SearchGrid = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
`;

const SearchInput = styled.input`
  ${backgroundColor2};
  ${fontSize2};
  border: 1px solid;
  height: 25px;
  color: #1163c9;
  place-self: center left;
`

// Create the debounce function
const handleFilter = _.debounce((inputValue, coinList, setFilterCoins) => {
  // Get all the coin symbols
  let coinSymbols = Object.keys(coinList);
  // Get all the coin names, map symbol to name
  let coinNames = coinSymbols.map(sym => coinList[sym].CoinName);
  let allStringsToSearch = coinSymbols.concat(coinNames);
  //console.log(inputValue);
  let fuzzyResults = fuzzy
    .filter(inputValue, allStringsToSearch, {})
    .map(result => result.string);

  //console.log(fuzzyResults);//=> tested!==> returned a cleaner array

  let filteredCoins = _.pickBy(coinList, (result, symKey) => {
    // get the name of the Coin
    let coinName = result.CoinName;
    return (_.includes(fuzzyResults, symKey)|| _.includes(fuzzyResults, coinName));
  });
  console.log(filterCoins);
  setFilterCoins(filteredCoins);
  //console.log(fuzzyResults); //=> tested! it works
}, 500);

function filterCoins(e, setFilteredCoins, coinList) {
  // Get the inputValue
  let inputValue = e.target.value;
  //console.log(inputValue);
  if(!inputValue){
    setFilteredCoins(null);
    return;
  }
  handleFilter(inputValue, coinList, setFilteredCoins);
}

export default function() {
  return (
    <AppContext.Consumer>
      {({setFilteredCoins, coinList}) => 
        <SearchGrid> 
          <h2>Search all coins</h2>
          <SearchInput onKeyUp={(e)=> filterCoins(e, setFilteredCoins, coinList)}/>
        </SearchGrid>
    }
    </AppContext.Consumer>
  );
}